import React from 'react';
import { separatorString } from '../constants';
import { getItemId } from '../helpers';
const getItemsIdFromChildren = (children) => React.Children.toArray(children).map(getItemId).filter(Boolean);
function useItemsChanged(menuItems, items) {
    const [hash, setHash] = React.useState('');
    const domNodes = React.useMemo(() => getItemsIdFromChildren(menuItems), [menuItems]);
    React.useEffect(() => {
        const hash = domNodes.filter(Boolean).join('');
        const allItems = items.toItemsWithoutSeparators();
        const removed = allItems.filter((item) => !domNodes.includes(item));
        removed.forEach((item) => {
            var _a, _b;
            const isLast = ((_a = items.last()) === null || _a === void 0 ? void 0 : _a.key) === item;
            const lastSeparator = (isLast && ((_b = items.prev(item)) === null || _b === void 0 ? void 0 : _b.key)) || '';
            items.delete(lastSeparator);
            items.delete(`${item}${separatorString}`);
            items.delete(item);
        });
        setHash(hash);
    }, [domNodes, items]);
    return hash;
}
export default useItemsChanged;
